export const MS_PER_MINUTE = 60000; // 1000 * 60
export const MS_PER_FIVE_MINUTES = 300000; // 1000 * 60 * 5
export const MS_PER_DAY = 86400000; // 1000 * 60 * 60 * 24
export const MS_PER_HOUR = 3600000; // 1000 * 60 * 60

export const MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const FULL_MONTH = [
  'January', 'February', 'March', 'April',
  'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December',
];

// OrderRepository::WARRANTY_TIME_IN_DAYS
export const WARRANTY_DAY_COUNT = 5;

export const MOSCOW_H_TIMEZONE = 3;

export const ADMIN_TIMEZONE_OFFSET = -60 * MOSCOW_H_TIMEZONE;

export const SECONDS_PER_MINUTE = 60; // 60
export const SECONDS_PER_HOUR = 3600; // 60 * 60
export const SECONDS_PER_DAY = 86400; // 24 * 60 * 60
export const SECONDS_PER_THREE_MONTHS = 7776000; // 60 * 60 * 24 * 30 * 3
